<section class="ndf-management">
  <div class="ndf-management__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="ndf-management__header__map d-none">
      <i class="pi pi-map d-none"></i>
    </div>
  </div>
  <div class="ndf-management__header">
    <div class="ndf-management__header__title">
      <div class="ndf-management__header__title__icon" (click)="cancelDemand()">
        <i class="pi pi-arrow-left"></i>
      </div>
      <h1>{{ tk.Management.NdfDemand | t }}</h1>
    </div>
    <div class="ndf-management__header__action">
      <a
        [routerLink]="['/dashboard/ndf-operation/list']"
        [queryParams]="{ filter: demand?.sequentialId }">
        Ir para operações
      </a>
      <a href="javascript://" class="ms-3" (click)="openMtmForDemand()"> Ir para MTM </a>
      <a *ngIf="demandId" href="javascript://" class="ms-3" (click)="openBetaVersion()">
        Testar Nova Versão (Beta)
      </a>
    </div>
  </div>
  <div class="ndf-management__content">
    <div class="ndf-management__content__header">
      <form [formGroup]="demandForm" appAutoFormGroup>
        <div class="ndf-management__content__header__content">
          <div
            *ngIf="demand?.sequentialId"
            class="ndf-management__content__header__content__item"
            style="text-align: center">
            <p class="pill">
              {{ demand?.sequentialId }}
            </p>

            <!-- Pills para Comex e Loan -->
            <div
              style="
                display: flex;
                gap: 0.5rem;
                justify-content: center;
                margin-top: 0.5rem;
                flex-wrap: wrap;
              ">
              <a
                *ngIf="comexOperation?.sequentialId"
                (click)="openComexDetailsModal(comexOperationId!)"
                class="pill pill--link"
                style="font-size: 0.8rem; padding: 0.25rem 0.5rem; cursor: pointer">
                {{ comexOperation?.sequentialId }}
              </a>

              <a
                *ngIf="loanOperation?.sequentialId"
                (click)="openLoanDetailsModal(loanOperationId!)"
                class="pill pill--link"
                style="font-size: 0.8rem; padding: 0.25rem 0.5rem; cursor: pointer">
                {{ loanOperation?.sequentialId }}
              </a>
            </div>
          </div>

          <div class="ndf-management__content__header__content__item">
            <h3>{{ demand?.company?.displayName }}</h3>
            <p>
              {{ formatedCnpj }}
            </p>
          </div>

          <div class="ndf-management__content__header__content__item">
            <h3>{{ tk.Management.NdfCurrency | t }}</h3>
            <p>{{ currencyLabel }}</p>
          </div>
          <div class="ndf-management__content__header__content__item">
            <h3>{{ tk.Management.NdfOperationType | t }}</h3>
            <p>{{ operationTypeLabel }}</p>
          </div>
          <div class="ndf-management__content__header__content__item">
            <h3>{{ tk.Management.NdfValue | t }} ME</h3>
            <p>
              {{ valueMe }}
            </p>
          </div>
          <div class="ndf-management__content__header__content__item">
            <h3>{{ tk.Management.NdfDueDate | t }}</h3>
            <p>{{ demand?.dueAt || '' | vaultDate }}</p>
          </div>
          <div class="ndf-management__content__header__content__item">
            <h3>{{ tk.Management.BudgetRate1 | t }}</h3>
            <p *ngIf="!editReference">
              {{ (budgetRate | number: '1.4-4') || 0 }}
            </p>

            <app-input
              *ngIf="editReference"
              [type]="'number'"
              [controlName]="demandProps.budgetRate"
              [formGroup]="demandForm"
              [minFractionDigits]="4"
              theme="clean"
              [min]="0"
              [required]="false"
              (sendInputValue)="handleInputNumber($event, 'budgetRate')" />
          </div>
          <div class="ndf-management__content__header__content__item">
            <h3>{{ tk.Management.NdfReference | t }}</h3>
            <p *ngIf="!editReference">
              {{ demand?.reference }}
            </p>

            <app-input
              *ngIf="editReference"
              [type]="'text'"
              [placeholder]="(tk.Management.NdfReference | t) || ''"
              [controlName]="demandProps.reference"
              [required]="false"
              theme="clean"
              [textCenter]="false"
              (sendInputValue)="handleInputText($event, demandProps.reference)">
            </app-input>
          </div>
          <a href="javascript://" (click)="toggleEditReference()"
            ><i class="pi pi-pencil cursor-pointer table__icon"></i
          ></a>
        </div>
      </form>

      <div class="ndf-management__content__header__actions">
        <app-button
          class="ms-2"
          [id]="'cancel-register'"
          [label]="tk.User.Cancel | t"
          [type]="'button'"
          [theme]="'white'"
          (sendButtonClick)="cancelDemand()">
        </app-button>
        <ng-container *ngIf="demandId; else templateCreateDemand">
          <app-button
            *appHasPermission="demandPermissions.UPDATE"
            class="ms-2"
            [id]="'register-user'"
            [label]="tk.General.Save | t"
            [type]="'button'"
            [disabled]="!operationsIsValid || isFiltering || isLoading"
            (sendButtonClick)="registerDemand()">
          </app-button>
        </ng-container>
        <ng-template #templateCreateDemand>
          <app-button
            *appHasPermission="demandPermissions.CREATE"
            class="ms-2"
            [id]="'register-user'"
            [label]="tk.General.Save | t"
            [type]="'button'"
            [disabled]="!operationsIsValid"
            (sendButtonClick)="registerDemand()">
          </app-button>
        </ng-template>
      </div>
    </div>
    <div class="ndf-management__content__header ndf-management__content__header--shadow">
      <div
        class="ndf-management__content__header__content"
        style="display: flex; align-items: center; gap: 1rem; flex-wrap: wrap">
        <div style="display: flex; flex-direction: column; align-items: center; width: 100%">
          <h2 style="margin-bottom: 0">
            {{ tk.Management.NdfYouHave | t }}
            <b>{{ demand?.operations?.length }} Operações</b>
          </h2>
          <div
            *ngIf="filteredOperations.length !== demand?.operations?.length"
            style="
              font-size: 0.9em;
              color: #888;
              margin-top: -0.5rem;
              margin-bottom: 0.5rem;
              width: 100%;
              text-align: center;
            ">
            exibindo {{ filteredOperations.length }} filtradas
          </div>
        </div>
        <app-input
          type="text"
          style="min-width: 200px; margin-left: 1rem"
          placeholder="Buscar por código ou referência"
          [(ngModel)]="textFilter"
          (ngModelChange)="onTextFilterChange()" />
        <app-select
          [options]="operationStatusOptions"
          [optionLabel]="'label'"
          [placeholder]="'Status Operação'"
          [selectedOption]="selectedOperationStatus"
          (sendSelectedOption)="onFilterChange('operationStatus', $event!)"
          style="min-width: 180px"></app-select>
        <ng-container *ngIf="selectedOperationStatus.value === 'Hired'">
          <app-select
            [options]="financialStatusOptions"
            [optionLabel]="'label'"
            [placeholder]="'Status Financeiro'"
            [selectedOption]="selectedFinancialStatus"
            (sendSelectedOption)="onFilterChange('financialStatus', $event!)"
            style="min-width: 180px"></app-select>
          <app-select
            [options]="compositionOptions"
            [optionLabel]="'label'"
            [placeholder]="'Composição'"
            [selectedOption]="selectedComposition"
            (sendSelectedOption)="onFilterChange('composition', $event!)"
            style="min-width: 180px"></app-select>
        </ng-container>
      </div>
      <div class="ndf-management__content__header__content">
        <app-button
          *appHasPermission="demandPermissions.SIMULATE"
          class="ms-2"
          [id]="'add-simulation'"
          [label]="(tk.Management.NdfAddSimulation | t) || ''"
          [icon]="'pi pi-plus-circle'"
          [type]="'button'"
          [theme]="'dashed'"
          (sendButtonClick)="addSimulation()"></app-button>

        <app-button
          *appHasPermission="demandPermissions.SIMULATE"
          class="ms-2"
          [id]="'add-simulation'"
          [label]="tk.General.CreateWithCogAi | t"
          [icon]="'pi pi-fw pi-microchip-ai'"
          [type]="'button'"
          [theme]="'dashed'"
          (sendButtonClick)="modalCreateOperationsWithCog.open()"></app-button>

        @if (hasSelectedOperations) {
          <app-button
            *appHasPermission="demandPermissions.SIMULATE"
            class="ms-2"
            [id]="'add-report'"
            [label]="tk.General.Export1 | t"
            [icon]="'pi pi-arrow-up'"
            [type]="'button'"
            [theme]="'dashed'"
            (sendButtonClick)="exportOperations()"></app-button>
          <app-button
            class="ms-2"
            [label]="'MTM'"
            [icon]="'pi pi-chart-line'"
            [type]="'button'"
            [theme]="'dashed'"
            (sendButtonClick)="openMtmForSelected()"></app-button>
        }
      </div>
    </div>

    <app-ndf-management-grid
      #grid
      *ngIf="demand"
      [demand]="demand"
      [disableFees]="disableFees"
      [operations]="filteredOperations"
      (sendAnnualCostByScenarios)="handleAnnualCostByScenarios($event)"
      (sendUpdatedDemand)="handleUpdatedDemand($event)"
      (sendOperationAction)="handleOperationAction($event)"></app-ndf-management-grid>
  </div>
</section>

<section class="ndf-management__graph">
  <div class="ndf-management__graph__header">
    <h3>{{ tk.Management.NdfCostPerYearScenarioReferenceExchangeRate | t }}</h3>
  </div>
  <div class="ndf-management__graph__content">
    <div class="card-info__item__chart">
      <canvas id="ndf-line-chart">{{ ndfLineChart }}</canvas>
    </div>
  </div>
</section>

<app-derivative-mtm-results-modal #resultsModal></app-derivative-mtm-results-modal>

<app-dialog
  #modalQuote
  [key]="'quote-operation'"
  [action]="'quote-operation'"
  [headerTheme]="'simple'"
  [title]="(tk.Management.NdfQuote | t) || ''">
  <form *ngIf="operationQuoteForm" [formGroup]="operationQuoteForm" appAutoFormGroup>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-6">
          <app-calendar
            [label]="(tk.Management.NdfDateAndTime | t) || ''"
            [placeholder]="(tk.General.Insert | t) || ''"
            [maxDate]="selectedOperationDueAt"
            [date]="dateTimeQuoted"
            [showTime]="true"
            [inputId]="'operation-quote'"
            (sendCalendarValue)="handleCalendarValue($event, 'quote')" />
        </div>
        <div class="col-12 col-md-6">
          <app-input
            [type]="'text'"
            [placeholder]="(tk.General.Insert | t) || ''"
            [controlName]="operationQuoteHireProps.bankOperatorName"
            [label]="tk.Management.NdfFinancialOperator | t"
            [required]="false">
          </app-input>
        </div>
      </div>
    </div>
  </form>
</app-dialog>

<app-dialog
  #modalQuoteConfirmation
  [key]="'quote-operation-confirmation'"
  [action]="'quote-operation-confirmation'"
  [headerTheme]="'simple'"
  [breakpoints]="{
    '960px': '400px',
    '768px': '70vw',
    '640px': '100vw',
    '480px': '100vw',
  }"
  [title]="''">
  <div class="container-fluid">
    <div class="row">
      <h2 style="font-size: 1.5rem; text-align: center">
        {{ tk.Management.NdfQuotationDateHourConfirmation | t }}
        {{ dateTimeQuoted | date: 'dd/MM/yyyy' }}?
      </h2>
    </div>
  </div>
</app-dialog>

<app-dialog
  #modalHireConfirmation
  [key]="'hire-operation-confirmation'"
  [action]="'hire-operation-confirmation'"
  [headerTheme]="'simple'"
  [breakpoints]="{
    '960px': '400px',
    '768px': '70vw',
    '640px': '100vw',
    '480px': '100vw',
  }"
  [title]="''">
  <div class="container-fluid">
    <div class="row">
      <h2 style="font-size: 1.5rem; text-align: center">
        {{ tk.Management.NdfHireDateHourConfirmation | t }}
        {{ dateTimeHired | date: 'dd/MM/yyyy' }}?
      </h2>
    </div>
  </div>
</app-dialog>

<app-dialog
  #modalHire
  [key]="'hire-operation'"
  [action]="'hire-operation'"
  [headerTheme]="'simple'"
  [breakpoints]="{
    '960px': '400px',
    '768px': '70vw',
    '640px': '100vw',
    '480px': '100vw',
  }"
  [title]="(tk.Management.NdfHireQuote | t) || ''">
  <form *ngIf="operationHireForm" [formGroup]="operationHireForm" appAutoFormGroup>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="mb-3">
            <app-calendar
              [date]="dateTimeHired"
              [label]="(tk.Management.NdfDateAndTime | t) || ''"
              [placeholder]="(tk.General.Insert | t) || ''"
              [maxDate]="selectedOperationDueAt"
              [showTime]="true"
              [inputId]="'operation-hire'"
              (sendCalendarValue)="handleCalendarValue($event, 'hire')" />
          </div>
        </div>
        <div class="col-12 col-md-6">
          <app-input
            [type]="'text'"
            [placeholder]="(tk.General.Insert | t) || ''"
            [controlName]="operationQuoteHireProps.bankOperatorName"
            [label]="tk.Management.NdfFinancialOperator | t"
            [required]="false">
          </app-input>
        </div>
      </div>
    </div>
  </form>

  <app-card-summary *ngIf="derivativeCardInfo" [cardInfo]="derivativeCardInfo" [isCollapsed]="true">
    <app-derivative-summary *ngIf="derivativeSummary" [derivative]="derivativeSummary" />
  </app-card-summary>
</app-dialog>

<app-ndf-edit-demand (sendSuccessUpdate)="handleSuccessUpdate()" #editDemand></app-ndf-edit-demand>

<app-create-operations-with-cog-modal
  #modalCreateOperationsWithCog
  (sendOperations)="handleOperationsFromCog($event)" />

<app-modal-derivative-attachments #attachmentsModal (attachmentUploaded)="onAttachmentUploaded()">
</app-modal-derivative-attachments>

<app-modal-loan-details #loanDetailsModal></app-modal-loan-details>

<app-modal-comex-operation-details #comexDetailsModal></app-modal-comex-operation-details>
